import { useSearchParams, useNavigate } from 'react-router-dom';
import { UnifiedPageEditor } from '@/components/admin/visual-editor/UnifiedPageEditor';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

const PageBuilderAdmin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialPage = searchParams.get('page') || 'home';

  return (
    <ErrorBoundary title="Page Builder failed to load">
      <UnifiedPageEditor 
        initialPage={initialPage}
        openSeo={searchParams.get('seo') === '1'}
        onBack={() => navigate('/admin')}
      />
    </ErrorBoundary>
  );
};

export default PageBuilderAdmin;
